const actions = {
  SET_STATE: 'backlog/SET_STATE',
  GET_BACKLOG_CATEGORY: 'backlog/GET_BACKLOG_CATEGORY',
  GET_BACKLOG_TRANSACTIONS: 'backlog/GET_BACKLOG_TRANSACTIONS',
}

export default actions
